import React, { useState } from 'react';

export interface H2HPickerMember {
  id: string;
  name: string;
  nickname: string | null;
  avatar: string | null;
}

interface Props {
  open: boolean;
  members: H2HPickerMember[];
  initialA?: string;
  initialB?: string;
  onConfirm: (a: string, b: string) => void;
  onClose: () => void;
}

export function PlayerPickerModal({ open, members, initialA, initialB, onConfirm, onClose }: Props) {
  const [a, setA] = useState<string | null>(initialA ?? null);
  const [b, setB] = useState<string | null>(initialB ?? null);
  if (!open) return null;
  const canConfirm = a != null && b != null && a !== b;

  return (
    <div style={overlay}>
      <div style={card}>
        <h3 style={{ color: '#fff' }}>Elegí 2 jugadores</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          <div>
            <div style={section}>Jugador A</div>
            <ul style={list}>
              {members.map((m) => (
                <li
                  key={m.id}
                  data-testid={`h2h-picker-a-${m.id}`}
                  onClick={() => { if (m.id !== b) setA(m.id); }}
                  style={{ ...item, ...(a === m.id ? itemActive : null), cursor: m.id === b ? 'not-allowed' : 'pointer' }}
                >
                  {m.name}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div style={section}>Jugador B</div>
            <ul style={list}>
              {members.map((m) => (
                <li
                  key={m.id}
                  data-testid={`h2h-picker-b-${m.id}`}
                  onClick={() => { if (m.id !== a) setB(m.id); }}
                  style={{ ...item, ...(b === m.id ? itemActive : null), cursor: m.id === a ? 'not-allowed' : 'pointer' }}
                >
                  {m.name}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button onClick={onClose} style={btnSecondary}>Cancelar</button>
          <button
            data-testid="h2h-picker-confirm"
            disabled={!canConfirm}
            onClick={() => { if (canConfirm) onConfirm(a!, b!); }}
            style={canConfirm ? btnPrimary : btnPrimaryDisabled}
          >
            Comparar
          </button>
        </div>
      </div>
    </div>
  );
}

const overlay: React.CSSProperties = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
};
const card: React.CSSProperties = { width: 600, maxHeight: '85vh', overflow: 'auto', background: '#1a1a1a', borderRadius: 12, padding: 20 };
const section: React.CSSProperties = { color: '#aaa', fontSize: 13, marginBottom: 6 };
const list: React.CSSProperties = { listStyle: 'none', padding: 0, margin: 0, maxHeight: 280, overflow: 'auto', background: '#222', borderRadius: 8 };
const item: React.CSSProperties = { padding: 8, color: '#ddd', borderBottom: '1px solid #2a2a2a' };
const itemActive: React.CSSProperties = { background: '#2a4d8f', color: '#fff' };
const btnPrimary: React.CSSProperties = { background: '#4caf50', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: 8, cursor: 'pointer', fontWeight: 700 };
const btnPrimaryDisabled: React.CSSProperties = { ...btnPrimary, background: '#555', cursor: 'not-allowed' };
const btnSecondary: React.CSSProperties = { background: 'transparent', color: '#bbb', border: '1px solid #444', padding: '8px 16px', borderRadius: 8, cursor: 'pointer' };
